var _module_exports = "<div >\n    Please create a dashboard before creating a chart\n</div>";;
var path = '/builds/observability/imm/signalview/src/legacy/app/globalNav/globalActions/disabledChartTooltip.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;